export { FooterLinksList } from './footer-links-list';
